import { Dispensary } from "@/custom-types/Dispensary";

import { Modal } from "@/components/botanic/Modal";
import RetailerInfoSection from "@/components/Dispensary/AboutDispensary/RetailerInfoSection";

interface AboutModalProps {
  dispensary: Dispensary;
  onDismissed: () => void;
  returnFocusRef: React.RefObject<HTMLElement | null>;
}

const AboutModal: React.FC<AboutModalProps> = ({
  dispensary,
  onDismissed,
  returnFocusRef,
}) => (
  <Modal
    title="About"
    onDismissed={onDismissed}
    returnFocusRef={returnFocusRef}
  >
    <div className="flex flex-col gap-lg divide-y divide-grey-44 [&>*:not(:first-child)]:pt-lg">
      <RetailerInfoSection dispensary={dispensary} forModal />
    </div>
  </Modal>
);

export default AboutModal;
